import { colorPalette } from '../../colorPalette';
export const getClubRTagStyles = (format, size) => ({
    wrapper: Object.assign({ alignItems: size === 'small' ? 'center' : format === 'line' ? 'center' : 'flex-start', justifyContent: format === 'line' ? 'space-between' : 'center', p: size === 'small' ? '0 8px' : format === 'line' ? '0 12px' : '12px', width: format === 'line' ? 1 : size === 'small' ? '65px' : 'fit-content', height: format === 'line' ? '44px' : size === 'small' ? '48px' : '62px', minWidth: format === 'line' ? 1 : size === 'small' ? '65px' : '124px', maxWidth: format === 'line' ? 1 : size === 'small' ? '65px' : '200px' }, clubRTagStyle),
    container: {
        alignItems: format === 'line' || size === 'small' ? 'center' : 'flex-start',
        justifyContent: format === 'line' ? 'flex-start' : 'normal',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
    },
});
const clubRTagStyle = {
    position: 'relative',
    background: colorPalette.white,
    borderRadius: '8px',
    boxShadow: `inset -1px 0px 0px 0.5px ${colorPalette.gray200},
              inset -1px -1px 0px 0.5px ${colorPalette.gray200},
              inset -1px 1px 0px 0.5px ${colorPalette.gray200}`,
    borderLeft: `2px solid ${colorPalette.red800}`,
    '&:hover': {
        cursor: 'pointer',
        background: colorPalette.gray100,
    },
    '&:active': {
        background: colorPalette.gray200,
    },
    '&:focus': {
        border: `1px solid ${colorPalette.lightBlue800}`,
    },
};
// --------- Logo Club R ---------
export const clubRIconStyle = {
    borderRadius: '4px',
    background: colorPalette.gray100,
};
